import { IRescheduleSource } from "./rescheduleSource.reducer";

export const actionTypes = {
  SET_SOURCE: "SET_SOURCE",
} as const;

export const setRescheduleSourceAction = (rescheduleSource: IRescheduleSource) => ({
  type: actionTypes.SET_SOURCE,
  payload: rescheduleSource,
});

export const rescheduleSourceActions = {
  setRescheduleSourceAction,
};
